<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-file text-primary mr-2"></i>
                    Informe diario del asesor
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">

                <b-row slot="header" class="m-0 p-0 ">

                    <b-col class="col-4">
                        <b-form-group
                            label="Fecha del informe"
                            :label-cols="5"
                            :horizontal="true"
                            class="w-100 m-0">
                            <v-date-picker
                                :max-date="new Date()"
                                v-model="report.date"
                                class="p-0 form-controldate-picker-w-100 date-picker-custom-border">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col class="col-4">
                        <adviser-selector
                            v-if="mixinCheckPermission('QUERY_ADVISER_REPORT_ALL')"
                            v-model="report.adviser">
                        </adviser-selector>
                    </b-col>

                    <b-col class="col-4 p-0">
                        <button
                            @click="downloadReport"
                            :disabled="!queryActivities"
                            class="btn btn-primary btn-sm float-right ml-2">
                            <i class="fa fa-download"></i> Descargar
                        </button>
                        <button
                            @click="generateReport"
                            class="btn btn-primary btn-sm float-right">
                            <i class="fa fa-repeat"></i> Generar
                        </button>
                    </b-col>

                </b-row>

                <b-row v-if="!!queryActivities">

                    <b-col id="pdfContent">

                        <!--Report header-->
                        <b-row>

                            <b-col class="col-2">
                                <b-img src="img/logo.png" fluid alt="Logo de ATA Cloud"></b-img>
                            </b-col>

                            <b-col>
                                <h2 class="text-uppercase">INFORME DIARIO: {{report.adviser.firstname}} {{report.adviser.lastname}}</h2>
                                <h3>FECHA: {{moment(report.date).format('LL')}}</h3>
                            </b-col>

                        </b-row>

                        <!--Report resume-->
                        <b-row class="mt-4 mx-1">

                            <b-col class="col-3">
                                <h4>Consultas Abiertas</h4>
                            </b-col>

                            <b-col class="col-2" align="right">
                                Total {{openQueriesCount}}
                                <br>
                                Socios: {{openMemberQueriesCount}}
                                <br>
                                No Socios: {{openNoMemberQueriesCount}}
                            </b-col>

                            <b-col class="col-2" align="right">
                                En Plazo {{openNoDelayQueriesCount}}
                                <br>
                                {{openMemberNoDelayQueriesCount}}
                                <br>
                                {{openNoMemberNoDelayQueriesCount}}
                            </b-col>

                            <b-col class="col-2" align="right">
                                Demoradas {{openDelayQueriesCount}}
                                <br>
                                {{openMemberDelayQueriesCount}}
                                <br>
                                {{openNoMemberDelayQueriesCount}}
                            </b-col>

                        </b-row>

                        <b-row class="mt-4 mx-1">

                            <b-col>
                                <strong>Actividad {{moment(report.date).format('DD/MM/Y')}}</strong>
                            </b-col>

                            <b-col>
                                Consultas Resueltas {{resolvedQueriesCount}}
                            </b-col>

                            <b-col>
                                Consultas Cerradas {{closedQueriesCount}}
                            </b-col>

                            <b-col>
                                Incidencias generadas {{queryIssuesCount}}
                            </b-col>

                        </b-row>

                        <!--Query list-->
                        <b-row class="border mx-1 mt-2">

                            <b-col>

                                <b-row class="font-weight-bold">
                                    <b-col class="col-1">Consulta</b-col>
                                    <b-col class="col-2">Estado</b-col>
                                    <b-col class="col-4">Acciones</b-col>
                                    <b-col class="col-2">Usuario</b-col>
                                    <b-col>Tipo usuario</b-col>
                                    <b-col class="col-1">Demora</b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <hr class="m-0">
                                    </b-col>
                                </b-row>

                                <b-row
                                    v-for="(queryActivity, index) in queryActivities" key="queryActivity.query.uuid"
                                    :class="index % 2 == 0 ? '' : 'bg-gray-100'">

                                    <b-col class="col-1">
                                        {{queryActivity.query.number}}
                                    </b-col>

                                    <b-col class="col-2">
                                        {{queryActivity.query.status | queryStatus}}
                                    </b-col>

                                    <b-col class="col-4">
                                        <div v-for="activity in queryActivity.activities">
                                            {{activity.description}}
                                        </div>
                                    </b-col>

                                    <b-col class="col-2">
                                        {{queryActivity.query.client.name}}
                                    </b-col>

                                    <b-col>
                                        {{queryActivity.query.client.class | clientType}}
                                    </b-col>

                                    <b-col class="col-1">
                                        {{delayQuery(queryActivity)}}
                                    </b-col>

                                </b-row>

                            </b-col>

                        </b-row>

                    </b-col>

                </b-row>

                <b-row v-else class="text-center">
                    <b-col>
                        <span class="text-muted">Seleccione una fecha y pulse el botón para generar el informe</span>
                    </b-col>
                </b-row>

            </b-card>

        </b-row>

    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import {getQueryActivitiesReport} from "@/api/query-api";
    import {getParameters} from "@/api/parameter-api";
    import moment from "moment";
    import jsPDF from "jspdf";
    import html2canvas from 'html2canvas';
    import AdviserSelector from "@/components/users/AdviserSelector";

    export default {
        name: "QueryDailyReport",

        components: {
            AdviserSelector
        },

        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/queries/list',
                        brand: 'fa fa-home'
                    },
                ],
                report: {
                    date: null,
                    adviser: null
                },
                parameters: null,
                queryActivities: null
            }
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.report.date = new Date();
            this.report.adviser = this.authUser();
            this.parameters = this.getParameters();
        },

        computed: {

            openQueriesCount() {
                return this.countQueriesByStatus('OPEN') + this.countQueriesByStatus('REOPEN');
            },

            openMemberQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'member', null) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'member', null);
            },

            openNoMemberQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'no-member', null) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'no-member', null);
            },

            openNoDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'member', false) + this.countQueriesByStatusClientTypeDelay('OPEN', 'no-member', false) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'member', false) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'no-member', false);
            },

            openDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'member', true) + this.countQueriesByStatusClientTypeDelay('OPEN', 'no-member', true) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'member', true) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'no-member', true);
            },

            openMemberNoDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'member', false) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'member', false);
            },

            openNoMemberNoDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', "no-member", false) + this.countQueriesByStatusClientTypeDelay('REOPEN', "no-member", false);
            },

            openMemberDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', 'member', true) + this.countQueriesByStatusClientTypeDelay('REOPEN', 'member', true);
            },

            openNoMemberDelayQueriesCount() {
                return this.countQueriesByStatusClientTypeDelay('OPEN', "no-member", true) + this.countQueriesByStatusClientTypeDelay('REOPEN', "no-member", true);
            },

            resolvedQueriesCount() {
                return this.countQueriesByStatus('RESOLVED');
            },

            closedQueriesCount() {
                return this.countQueriesByStatus('CLOSED');
            },

            queryIssuesCount() {
                let count = 0;
                this.queryActivities.map((queryActivity) => {
                    count += queryActivity.query.issuesCount;
                });
                return count;
            }
        },

        methods: {

            ...mapGetters([
                'authUser',
            ]),

            getParameters() {
                let parameters = null;

                this.$_loadingMixin_showLoading();
                getParameters()
                    .then((parameters) => {
                        this.parameters = parameters;
                    });
                this.$_loadingMixin_hideLoading();

                return this.parameters;
            },

            countQueriesByStatus(status) {
                let count = 0;
                this.queryActivities.map((queryActivity) => {
                    if (queryActivity.query.status === status) {
                        count++
                    }
                });
                return count;
            },

            countQueriesByStatusClientTypeDelay(status, clientType, delay) {
                let parameter = null;
                let code = "";
                let count = 0;

                if (clientType == "member") {
                    code = "RESPONSE_TIME_FOR_MEMBER";
                }
                if (clientType == "no-member") {
                    code = "RESPONSE_TIME_FOR_NO_MEMBER";
                }

                this.parameters.map((parameter) => {
                    if (code == parameter.code) {
                        this.queryActivities.map((queryActivity) => {
                            if (queryActivity.query.status === status) {
                                if (
                                    clientType == "member"
                                    &&
                                    queryActivity.query.client.class.toLowerCase() == "member"
                                ) {
                                    if (delay != null) {
                                        if (
                                            moment().diff(moment(queryActivity.query.date), 'hours') > parameter.value
                                            &&
                                            delay == true
                                        ) {
                                            count++
                                        }
                                        if (
                                            moment().diff(moment(queryActivity.query.date), 'hours') <= parameter.value
                                            &&
                                            delay == false
                                        ) {
                                            count++
                                        }
                                    }
                                    else {
                                        count++
                                    }
                                }
                                if (clientType == "no-member"
                                    &&
                                    queryActivity.query.client.class.toLowerCase() != "member"
                                ) {
                                    if (delay != null) {
                                        if (
                                            moment().diff(moment(queryActivity.query.date), 'hours') > parameter.value
                                            &&
                                            delay == true
                                        ) {
                                            count++
                                        }
                                        if (
                                            moment().diff(moment(queryActivity.query.date), 'hours') <= parameter.value
                                            &&
                                            delay == false
                                        ) {
                                            count++
                                        }
                                    }
                                    else {
                                        count++
                                    }
                                }
                            }
                        });
                    }
                });

                return count;
            },

            moment(date) {
                return moment(date).locale("es");
            },

            delayQuery(queryActivity) {
                let delay = "No";
                let code = "";

                if (queryActivity.query.client.class.toLowerCase() == "member") {
                    code = "RESPONSE_TIME_FOR_MEMBER";
                }
                else {
                    code = "RESPONSE_TIME_FOR_NO_MEMBER";
                }

                this.parameters.map((parameter) => {
                    if (code == parameter.code) {
                        if (
                            queryActivity.query.status === "OPEN"
                            ||
                            queryActivity.query.status === "REOPEN"
                        ) {
                            if (moment().diff(moment(queryActivity.query.date), 'hours') > parameter.value) {
                                delay = moment().diff(moment(queryActivity.query.date), 'hours');
                            }
                        }
                        if (queryActivity.query.status === "RESOLVED") {
                            if (moment(queryActivity.query.resolvedAt).diff(moment(queryActivity.query.date), 'hours') > parameter.value) {
                                delay = moment(queryActivity.query.resolvedAt).diff(moment(queryActivity.query.date), 'hours');
                            }
                        }
                        if (
                            queryActivity.query.status === "CLOSED"
                            ||
                            queryActivity.query.status === "REASSIGNED"
                        ) {
                            delay = "";
                        }
                    }
                });         
                
                return delay;
            },

            generateReport() {
                this.$_loadingMixin_showLoading();
                getQueryActivitiesReport(this.report.adviser.uuid, moment(this.report.date).format('YYYY-MM-DD'))
                    .then((queryActivities) => {

                        this.$_loadingMixin_hideLoading();

                        if (queryActivities.length == 0) {
                            this.$_notificationMixin_warn("No se encontraron datos", "No se han encontrado datos para generar el informe en la fecha seleccionada");
                            return;
                        }

                        this.queryActivities = queryActivities;
                    })
                    .catch(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error("Error al generar el informe. Se ha producido un error al intentar recuperar los datos para generar el informe");
                    });
            },

            downloadReport() {

                html2canvas(document.getElementById("pdfContent"))
                    .then((canvas) => {
                        let pdf = new jsPDF();
                        pdf.addImage(canvas.toDataURL("image/png"), 'JPEG', 0, 5, 210, 0);
                        pdf.save('test.pdf');
                    });
            }
        },

        filters: {
            queryStatus(value) {
                switch (value) {
                    case 'OPEN':
                        return 'Abierta';
                    case 'CLOSED':
                        return 'Cerrada';
                    case 'REOPEN':
                        return 'Reabierta';
                    case 'REASSIGNED':
                        return 'Reasignada';
                    case 'RESOLVED':
                        return 'Resuelta';
                    default:
                        return 'Desconocido';
                }
            },

            clientType(value) {
                switch (value) {
                    case 'Client':
                        return 'No socio';
                    case 'Member':
                        return 'Socio';
                    case 'LinkedMember':
                        return 'Socio asociado';
                    default:
                        return 'Desconocido';
                }
            },

        }
    }
</script>